// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClientDetail_page__fcyzE {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Header bar */
.ClientDetail_headerBar__dbx\\+c {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 24px;
}
.ClientDetail_title__Pkhbz {
  font-size: 24px;
  font-weight: 700;
  color: var(--dylo-ink);
  margin: 0;
}
.ClientDetail_headerActions__zJlZq {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.ClientDetail_iconBtn__imWLB {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid var(--dylo-surface-border);
  background: var(--dylo-field-bg);
  color: var(--dylo-ink);
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;
}
.ClientDetail_iconBtn__imWLB:hover {
  border-color: var(--dylo-teal-500);
  color: var(--dylo-teal-700);
}

/* Botón de texto en la barra del encabezado.
   ⚠️ NO reusa \`.iconBtn\`: ese mide 36x36 fijos y "Deactivate" no cabe — se saldría del
   cuadro o se recortaría. Comparte la piel y suelta el tamaño. */
.ClientDetail_stateBtn__gyQz5 {
  display: inline-flex;
  align-items: center;
  height: 36px;
  padding: 0 14px;
  border: 1px solid var(--dylo-surface-border);
  background: var(--dylo-field-bg);
  color: var(--dylo-ink);
  border-radius: 10px;
  font: inherit;
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: border-color 0.15s ease, color 0.15s ease;
}
.ClientDetail_stateBtn__gyQz5:hover {
  border-color: var(--dylo-orange);
  color: var(--dylo-orange);
}
.ClientDetail_stateBtn__gyQz5:disabled {
  opacity: 0.6;
  cursor: progress;
}

/* Estado del cliente junto al nombre. */
.ClientDetail_stateBadge__EHwXS {
  padding: 3px 10px;
  border-radius: 999px;
  border: 1px solid currentColor;
  background: color-mix(in srgb, currentColor 12%, transparent);
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  white-space: nowrap;
}
.ClientDetail_stateOn__Z1MTu {
  color: #2aad27;
}
/* Naranja y no rojo: un cliente inactivo no es un error, es una decisión. El rojo se
   reserva para lo que está roto. */
.ClientDetail_stateOff__yYZRV {
  color: var(--dylo-orange);
}
.ClientDetail_danger__549Hv:hover {
  border-color: var(--dylo-danger);
  color: var(--dylo-danger);
  background: color-mix(in srgb, var(--dylo-danger) 10%, transparent);
}

/* Grid 3 columnas */
.ClientDetail_grid__QftOB {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  align-items: start;
}
.ClientDetail_col__0T\\+IC {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.ClientDetail_colTitle__Sg5XY {
  font-size: 16px;
  font-weight: 700;
  color: var(--dylo-ink);
  margin: 0;
  letter-spacing: 0.3px;
}
.ClientDetail_colTools__XQIqV {
  display: flex;
  align-items: center;
  gap: 10px;
}
.ClientDetail_addBtn__KyB4P {
  white-space: nowrap;
  background: var(--dylo-teal-700) !important;
  border: none !important;
  font-size: 12.5px !important;
  padding: 8px 14px !important;
}
.ClientDetail_colSearch__kS0n8 {
  flex: 1 1;
  min-width: 0;
}
.ClientDetail_colList__0fzyV {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: calc(100vh - 290px);
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;
}
.ClientDetail_colList__0fzyV::-webkit-scrollbar {
  width: 6px;
}
.ClientDetail_colList__0fzyV::-webkit-scrollbar-thumb {
  background: color-mix(in srgb, var(--dylo-muted) 35%, transparent);
  border-radius: 3px;
}
.ClientDetail_colEmpty__QmsEU {
  padding: 24px;
  text-align: center;
  color: var(--dylo-muted);
  font-size: 13px;
  margin: 0;
}

.ClientDetail_rowItem__lvB4e {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 14px;
  border: 1px solid var(--dylo-line);
  border-radius: 12px;
  animation: ClientDetail_dylo-fade-in__erElI 0.24s ease both;
  transition: border-color 0.14s ease, transform 0.14s ease;
}
.ClientDetail_clickable__K993o {
  cursor: pointer;
}
.ClientDetail_clickable__K993o:hover {
  border-color: var(--dylo-teal-500);
  transform: translateY(-1px);
}
.ClientDetail_rowName__EDPii {
  font-size: 13px;
  color: var(--dylo-ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ClientDetail_rowRight__Dbqgq {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.ClientDetail_miniPill__93031 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  color: #2aad27;
  background: color-mix(in srgb, #2aad27 12%, transparent);
  border: 1px solid color-mix(in srgb, #2aad27 45%, transparent);
}
.ClientDetail_unassignBtn__pNREO {
  padding: 4px 12px;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--dylo-danger) 45%, transparent);
  background: transparent;
  color: var(--dylo-danger);
  font-family: var(--font-sans);
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.14s ease;
}
.ClientDetail_unassignBtn__pNREO:hover {
  background: color-mix(in srgb, var(--dylo-danger) 12%, transparent);
}

/* Modals */
.ClientDetail_form__wY7sT {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ClientDetail_formLabel__DVj5\\+ {
  font-size: 13px;
  font-weight: 600;
  color: var(--dylo-text);
}
.ClientDetail_formErr__N6XWW {
  font-size: 12.5px;
  color: var(--dylo-danger);
}
.ClientDetail_confirmText__Muevs {
  font-size: 13.5px;
  color: var(--dylo-text);
  line-height: 1.5;
  margin: 0;
}
.ClientDetail_confirmText__Muevs b {
  color: var(--dylo-ink);
}

.ClientDetail_assignBox__UOWLp {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.ClientDetail_assignList__l0zCN {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: calc(100vh - 320px);
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;
}
.ClientDetail_assignList__l0zCN::-webkit-scrollbar {
  width: 6px;
}
.ClientDetail_assignList__l0zCN::-webkit-scrollbar-thumb {
  background: color-mix(in srgb, var(--dylo-muted) 35%, transparent);
  border-radius: 3px;
}
.ClientDetail_assignRow__J9isj {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 14px;
  border: 1px solid var(--dylo-line);
  border-radius: 12px;
  background: transparent;
  color: var(--dylo-ink);
  font-family: var(--font-sans);
  text-align: left;
  cursor: pointer;
  transition: border-color 0.14s ease, background 0.14s ease;
}
.ClientDetail_assignRow__J9isj:hover {
  border-color: var(--dylo-teal-500);
}
.ClientDetail_assignRowActive__I8bJi {
  border-color: var(--dylo-teal-700);
  background: color-mix(in srgb, var(--dylo-teal-700) 8%, transparent);
}
.ClientDetail_assignRadio__0EcZm {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  border-radius: 50%;
  border: 2px solid var(--dylo-field-border);
  transition: border-color 0.14s ease, box-shadow 0.14s ease;
}
.ClientDetail_assignRadioOn__4oSEF {
  border-color: var(--dylo-teal-700);
  box-shadow: inset 0 0 0 4px var(--dylo-teal-700);
}
.ClientDetail_dangerBtn__M4uDe {
  background: var(--dylo-danger) !important;
  border: none !important;
}

/* Skeleton */
.ClientDetail_skRounded__3C4dw {
  border-radius: 10px !important;
}

/* \`minmax(0, 1fr)\` y no \`1fr\` (26-oct-2026): con \`1fr\` la columna no baja del ancho mínimo de un campo (el buscador de
   embarques, los contactos), que en el iPhone es más ancho que en Chromium (lo que le pasaba al login). */
@media (max-width: 1000px) {
  .ClientDetail_grid__QftOB {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* Insignia de modo en el encabezado.
   ⚠️ \`margin-right: auto\` en lugar de dejarla suelta: \`.headerBar\` usa
   space-between, así que como tercer hijo quedaría flotando en el centro,
   separada del nombre al que describe. El margen automático se come el espacio
   libre y la mantiene pegada al título, con los botones a la derecha. */
.ClientDetail_headerModes__SfVyt {
  margin-right: auto;
}

/* ------------------- Total y paginado de las columnas ----------------------
   El total va junto al titulo porque con la lista paginada ya no se puede
   obtener contando renglones.

   Aqui SI se pintan numeros de pagina -"1 / 4"- porque el total es exacto: la
   lista completa esta en memoria. La columna de envios pagina en el servidor y
   con busqueda no tiene total exacto, asi que alla solo hay anterior/siguiente.
   ------------------------------------------------------------------------ */
.ClientDetail_colCount__Wn-oc {
  margin-left: 7px;
  font-size: 11px;
  font-weight: 500;
  color: var(--dylo-muted);
  padding: 1px 7px;
  border: 1px solid var(--dylo-border);
  border-radius: 10px;
  font-variant-numeric: tabular-nums;
}

.ClientDetail_colPager__qZfbc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 10px;
  padding-top: 9px;
  border-top: 1px solid var(--dylo-border);
}
.ClientDetail_colPagerBtn__84bzH {
  padding: 3px 10px;
  border: 1px solid var(--dylo-border);
  border-radius: 6px;
  background: transparent;
  color: var(--dylo-text);
  font-size: 11.5px;
  cursor: pointer;
}
.ClientDetail_colPagerBtn__84bzH:hover:not(:disabled) {
  border-color: var(--dylo-accent, #4a9ee0);
}
.ClientDetail_colPagerBtn__84bzH:disabled {
  opacity: 0.4;
  cursor: default;
}
.ClientDetail_colPagerAt__soJr3 {
  font-size: 11px;
  color: var(--dylo-muted);
  font-variant-numeric: tabular-nums;
}

/*
 * El encabezado en el teléfono (21-oct-2026). En una sola fila, el nombre, las insignias y los botones no cabían en
 * ~320 px y los botones quedaban cortados a la derecha. El nombre va en su propia línea y lo demás debajo, con los
 * botones a la derecha. Va al final del archivo para ganarle a las reglas de arriba con la misma especificidad.
 */
@media (max-width: 720px) {
  .ClientDetail_headerBar__dbx\\+c {
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 10px 12px;
    padding: 14px 16px;
  }
  .ClientDetail_title__Pkhbz {
    flex: 1 1 100%;
    font-size: 20px;
    overflow-wrap: anywhere;
  }
  .ClientDetail_headerActions__zJlZq {
    margin-left: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/ClientDetail/ClientDetail.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,gCAAgC;EAChC,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,4EAA4E;AAC9E;AACA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;;iEAEiE;AACjE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,4CAA4C;EAC5C,gCAAgC;EAChC,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qDAAqD;AACvD;AACA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,oBAAoB;EACpB,8BAA8B;EAC9B,6DAA6D;EAC7D,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;mCACmC;AACnC;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,mEAAmE;AACrE;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,uBAAuB;EACvB,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;EACrB,mFAAmF;AACrF;AACA;EACE,UAAU;AACZ;AACA;EACE,kEAAkE;EAClE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,2DAAuC;EACvC,yDAAyD;AAC3D;AACA;EACE,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,wDAAwD;EACxD,8DAA8D;AAChE;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,yEAAyE;EACzE,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,mEAAmE;AACrE;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;EACrB,mFAAmF;AACrF;AACA;EACE,UAAU;AACZ;AACA;EACE,kEAAkE;EAClE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,oEAAoE;AACtE;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,0DAA0D;AAC5D;AACA;EACE,kCAAkC;EAClC,gDAAgD;AAClD;AACA;EACE,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA,aAAa;AACb;EACE,8BAA8B;AAChC;;AAEA;0GAC0G;AAC1G;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;;;;wEAIwE;AACxE;EACE,kBAAkB;AACpB;;AAEA;;;;;;;6EAO6E;AAC7E;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;AAC1C;AACA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;;;;EAIE;AACF;EACE;IACE,eAAe;IACf,2BAA2B;IAC3B,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".page {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Header bar */\n.headerBar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px 24px;\n}\n.title {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n  margin: 0;\n}\n.headerActions {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n.iconBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: 1px solid var(--dylo-surface-border);\n  background: var(--dylo-field-bg);\n  color: var(--dylo-ink);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;\n}\n.iconBtn:hover {\n  border-color: var(--dylo-teal-500);\n  color: var(--dylo-teal-700);\n}\n\n/* Botón de texto en la barra del encabezado.\n   ⚠️ NO reusa `.iconBtn`: ese mide 36x36 fijos y \"Deactivate\" no cabe — se saldría del\n   cuadro o se recortaría. Comparte la piel y suelta el tamaño. */\n.stateBtn {\n  display: inline-flex;\n  align-items: center;\n  height: 36px;\n  padding: 0 14px;\n  border: 1px solid var(--dylo-surface-border);\n  background: var(--dylo-field-bg);\n  color: var(--dylo-ink);\n  border-radius: 10px;\n  font: inherit;\n  font-size: 12.5px;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: border-color 0.15s ease, color 0.15s ease;\n}\n.stateBtn:hover {\n  border-color: var(--dylo-orange);\n  color: var(--dylo-orange);\n}\n.stateBtn:disabled {\n  opacity: 0.6;\n  cursor: progress;\n}\n\n/* Estado del cliente junto al nombre. */\n.stateBadge {\n  padding: 3px 10px;\n  border-radius: 999px;\n  border: 1px solid currentColor;\n  background: color-mix(in srgb, currentColor 12%, transparent);\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n.stateOn {\n  color: #2aad27;\n}\n/* Naranja y no rojo: un cliente inactivo no es un error, es una decisión. El rojo se\n   reserva para lo que está roto. */\n.stateOff {\n  color: var(--dylo-orange);\n}\n.danger:hover {\n  border-color: var(--dylo-danger);\n  color: var(--dylo-danger);\n  background: color-mix(in srgb, var(--dylo-danger) 10%, transparent);\n}\n\n/* Grid 3 columnas */\n.grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n  align-items: start;\n}\n.col {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.colTitle {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n  margin: 0;\n  letter-spacing: 0.3px;\n}\n.colTools {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.addBtn {\n  white-space: nowrap;\n  background: var(--dylo-teal-700) !important;\n  border: none !important;\n  font-size: 12.5px !important;\n  padding: 8px 14px !important;\n}\n.colSearch {\n  flex: 1;\n  min-width: 0;\n}\n.colList {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: calc(100vh - 290px);\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;\n}\n.colList::-webkit-scrollbar {\n  width: 6px;\n}\n.colList::-webkit-scrollbar-thumb {\n  background: color-mix(in srgb, var(--dylo-muted) 35%, transparent);\n  border-radius: 3px;\n}\n.colEmpty {\n  padding: 24px;\n  text-align: center;\n  color: var(--dylo-muted);\n  font-size: 13px;\n  margin: 0;\n}\n\n.rowItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 12px 14px;\n  border: 1px solid var(--dylo-line);\n  border-radius: 12px;\n  animation: dylo-fade-in 0.24s ease both;\n  transition: border-color 0.14s ease, transform 0.14s ease;\n}\n.clickable {\n  cursor: pointer;\n}\n.clickable:hover {\n  border-color: var(--dylo-teal-500);\n  transform: translateY(-1px);\n}\n.rowName {\n  font-size: 13px;\n  color: var(--dylo-ink);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.rowRight {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n.miniPill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #2aad27;\n  background: color-mix(in srgb, #2aad27 12%, transparent);\n  border: 1px solid color-mix(in srgb, #2aad27 45%, transparent);\n}\n.unassignBtn {\n  padding: 4px 12px;\n  border-radius: 999px;\n  border: 1px solid color-mix(in srgb, var(--dylo-danger) 45%, transparent);\n  background: transparent;\n  color: var(--dylo-danger);\n  font-family: var(--font-sans);\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.14s ease;\n}\n.unassignBtn:hover {\n  background: color-mix(in srgb, var(--dylo-danger) 12%, transparent);\n}\n\n/* Modals */\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.formLabel {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--dylo-text);\n}\n.formErr {\n  font-size: 12.5px;\n  color: var(--dylo-danger);\n}\n.confirmText {\n  font-size: 13.5px;\n  color: var(--dylo-text);\n  line-height: 1.5;\n  margin: 0;\n}\n.confirmText b {\n  color: var(--dylo-ink);\n}\n\n.assignBox {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.assignList {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: calc(100vh - 320px);\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;\n}\n.assignList::-webkit-scrollbar {\n  width: 6px;\n}\n.assignList::-webkit-scrollbar-thumb {\n  background: color-mix(in srgb, var(--dylo-muted) 35%, transparent);\n  border-radius: 3px;\n}\n.assignRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 12px 14px;\n  border: 1px solid var(--dylo-line);\n  border-radius: 12px;\n  background: transparent;\n  color: var(--dylo-ink);\n  font-family: var(--font-sans);\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.14s ease, background 0.14s ease;\n}\n.assignRow:hover {\n  border-color: var(--dylo-teal-500);\n}\n.assignRowActive {\n  border-color: var(--dylo-teal-700);\n  background: color-mix(in srgb, var(--dylo-teal-700) 8%, transparent);\n}\n.assignRadio {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  border: 2px solid var(--dylo-field-border);\n  transition: border-color 0.14s ease, box-shadow 0.14s ease;\n}\n.assignRadioOn {\n  border-color: var(--dylo-teal-700);\n  box-shadow: inset 0 0 0 4px var(--dylo-teal-700);\n}\n.dangerBtn {\n  background: var(--dylo-danger) !important;\n  border: none !important;\n}\n\n/* Skeleton */\n.skRounded {\n  border-radius: 10px !important;\n}\n\n/* `minmax(0, 1fr)` y no `1fr` (26-oct-2026): con `1fr` la columna no baja del ancho mínimo de un campo (el buscador de\n   embarques, los contactos), que en el iPhone es más ancho que en Chromium (lo que le pasaba al login). */\n@media (max-width: 1000px) {\n  .grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n/* Insignia de modo en el encabezado.\n   ⚠️ `margin-right: auto` en lugar de dejarla suelta: `.headerBar` usa\n   space-between, así que como tercer hijo quedaría flotando en el centro,\n   separada del nombre al que describe. El margen automático se come el espacio\n   libre y la mantiene pegada al título, con los botones a la derecha. */\n.headerModes {\n  margin-right: auto;\n}\n\n/* ------------------- Total y paginado de las columnas ----------------------\n   El total va junto al titulo porque con la lista paginada ya no se puede\n   obtener contando renglones.\n\n   Aqui SI se pintan numeros de pagina -\"1 / 4\"- porque el total es exacto: la\n   lista completa esta en memoria. La columna de envios pagina en el servidor y\n   con busqueda no tiene total exacto, asi que alla solo hay anterior/siguiente.\n   ------------------------------------------------------------------------ */\n.colCount {\n  margin-left: 7px;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--dylo-muted);\n  padding: 1px 7px;\n  border: 1px solid var(--dylo-border);\n  border-radius: 10px;\n  font-variant-numeric: tabular-nums;\n}\n\n.colPager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 10px;\n  padding-top: 9px;\n  border-top: 1px solid var(--dylo-border);\n}\n.colPagerBtn {\n  padding: 3px 10px;\n  border: 1px solid var(--dylo-border);\n  border-radius: 6px;\n  background: transparent;\n  color: var(--dylo-text);\n  font-size: 11.5px;\n  cursor: pointer;\n}\n.colPagerBtn:hover:not(:disabled) {\n  border-color: var(--dylo-accent, #4a9ee0);\n}\n.colPagerBtn:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n.colPagerAt {\n  font-size: 11px;\n  color: var(--dylo-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n/*\n * El encabezado en el teléfono (21-oct-2026). En una sola fila, el nombre, las insignias y los botones no cabían en\n * ~320 px y los botones quedaban cortados a la derecha. El nombre va en su propia línea y lo demás debajo, con los\n * botones a la derecha. Va al final del archivo para ganarle a las reglas de arriba con la misma especificidad.\n */\n@media (max-width: 720px) {\n  .headerBar {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    gap: 10px 12px;\n    padding: 14px 16px;\n  }\n  .title {\n    flex: 1 1 100%;\n    font-size: 20px;\n    overflow-wrap: anywhere;\n  }\n  .headerActions {\n    margin-left: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `ClientDetail_page__fcyzE`,
	"headerBar": `ClientDetail_headerBar__dbx+c`,
	"title": `ClientDetail_title__Pkhbz`,
	"headerActions": `ClientDetail_headerActions__zJlZq`,
	"iconBtn": `ClientDetail_iconBtn__imWLB`,
	"stateBtn": `ClientDetail_stateBtn__gyQz5`,
	"stateBadge": `ClientDetail_stateBadge__EHwXS`,
	"stateOn": `ClientDetail_stateOn__Z1MTu`,
	"stateOff": `ClientDetail_stateOff__yYZRV`,
	"danger": `ClientDetail_danger__549Hv`,
	"grid": `ClientDetail_grid__QftOB`,
	"col": `ClientDetail_col__0T+IC`,
	"colTitle": `ClientDetail_colTitle__Sg5XY`,
	"colTools": `ClientDetail_colTools__XQIqV`,
	"addBtn": `ClientDetail_addBtn__KyB4P`,
	"colSearch": `ClientDetail_colSearch__kS0n8`,
	"colList": `ClientDetail_colList__0fzyV`,
	"colEmpty": `ClientDetail_colEmpty__QmsEU`,
	"rowItem": `ClientDetail_rowItem__lvB4e`,
	"dylo-fade-in": `ClientDetail_dylo-fade-in__erElI`,
	"clickable": `ClientDetail_clickable__K993o`,
	"rowName": `ClientDetail_rowName__EDPii`,
	"rowRight": `ClientDetail_rowRight__Dbqgq`,
	"miniPill": `ClientDetail_miniPill__93031`,
	"unassignBtn": `ClientDetail_unassignBtn__pNREO`,
	"form": `ClientDetail_form__wY7sT`,
	"formLabel": `ClientDetail_formLabel__DVj5+`,
	"formErr": `ClientDetail_formErr__N6XWW`,
	"confirmText": `ClientDetail_confirmText__Muevs`,
	"assignBox": `ClientDetail_assignBox__UOWLp`,
	"assignList": `ClientDetail_assignList__l0zCN`,
	"assignRow": `ClientDetail_assignRow__J9isj`,
	"assignRowActive": `ClientDetail_assignRowActive__I8bJi`,
	"assignRadio": `ClientDetail_assignRadio__0EcZm`,
	"assignRadioOn": `ClientDetail_assignRadioOn__4oSEF`,
	"dangerBtn": `ClientDetail_dangerBtn__M4uDe`,
	"skRounded": `ClientDetail_skRounded__3C4dw`,
	"headerModes": `ClientDetail_headerModes__SfVyt`,
	"colCount": `ClientDetail_colCount__Wn-oc`,
	"colPager": `ClientDetail_colPager__qZfbc`,
	"colPagerBtn": `ClientDetail_colPagerBtn__84bzH`,
	"colPagerAt": `ClientDetail_colPagerAt__soJr3`
};
export default ___CSS_LOADER_EXPORT___;
